import { ReactNode, useEffect, useState } from 'react'
import { Collapse, Grow } from '@mui/material'

type ExpandAndGrowProps = {
  show: boolean
  children: ReactNode
  expandedHeight: number
}

export default function ExpandAndGrow({
  show,
  children,
  expandedHeight,
}: ExpandAndGrowProps) {
  // These are both defaulted to "show" so that if show is true on first render,
  // we don't have to wait for useEffect to kick in to start the animations.
  const [shouldExpand, setShouldExpand] = useState(show)
  const [shouldGrow, setShouldGrow] = useState(show)

  useEffect(() => {
    if (show) {
      // This handles when we first switch "show" to true.
      // We want to expand the card first, then grow the contents.
      // Once shouldExpand is true, the onEntered callback of Collapse will set shouldGrow to true.
      setShouldExpand(true)
    } else {
      // This handles when we switch "show" to false.
      // We want to shrink the contents first, then collapse the card.
      // Once shouldGrow is false, the onExited callback of Grow will set shouldExpand to false.
      setShouldGrow(false)
    }
  }, [show])

  return (
    <Collapse
      in={shouldExpand}
      unmountOnExit
      mountOnEnter
      onEntered={() => setShouldGrow(true)}
    >
      {/* Div required for Collapse to work */}
      <div style={{ height: expandedHeight }}>
        <Grow
          in={shouldGrow}
          unmountOnExit
          mountOnEnter
          onExited={() => setShouldExpand(false)}
        >
          {/* Div required for Grow to work */}
          <div>{children}</div>
        </Grow>
      </div>
    </Collapse>
  )
}
